export default __webpack_public_path__ + "static/media/hexagons-no-1.59b6af7a.ogg";